<template>
  <div class="app-modal-wrap">
    <button @click="openMakeDonationModal" class="btn btn-danger app-btn">
      Donate Now
    </button>

    <vodal
      :show="showMakeDonationModal"
      :height="600"
      :width="360"
      animation="zoom"
      @hide="closeMakeDonationModal"
    >
      <div class="app-modal">
        <p class="modal-title">Make a Donation</p>
        <MakeDonationForm @donationWalletCreated="donationWalletCreated" />
      </div>
    </vodal>

    <vodal
      :show="showDonationWalletModal"
      :height="530"
      :width="360"
      animation="zoom"
      :closeOnClickMask="false"
      :closeButton="false"
      @hide="closeDonationWalletModal"
    >
      <div class="app-modal">
        <DonationWalletCard @iHaveMadePayment="iHaveMadePayment" />
      </div>
    </vodal>
  </div>
</template>

<script>
import MakeDonationForm from "../Forms/MakeDonationForm";
import DonationWalletCard from "../Cards/DonationWalletCard";
export default {
  name: "SocialShareModal",
  components: { MakeDonationForm, DonationWalletCard },
  data() {
    return {
      showMakeDonationModal: false,
      showDonationWalletModal: false
    };
  },
  methods: {
    donationWalletCreated() {
      this.closeMakeDonationModal();
      this.openDonationWalletModal();
    },
    iHaveMadePayment() {
      this.$store
        .dispatch("payments/checkPaymentStatus", null, { root: true })
        .then(response => {
          if (
            response.responsecode === "00" ||
            response.responsecode === "20"
          ) {
            this.closeDonationWalletModal();
            this.$store.dispatch("payments/showPaymentsReceivedModal", true, {
              root: true
            });
          }
        });
    },
    openDonationWalletModal() {
      this.showDonationWalletModal = true;
    },
    closeDonationWalletModal() {
      this.showDonationWalletModal = false;
    },
    openMakeDonationModal() {
      this.showMakeDonationModal = true;
    },
    closeMakeDonationModal() {
      this.showMakeDonationModal = false;
    }
  }
};
</script>

<style scoped></style>
